/**
 * Fachada pública da fila — compatibilidade com imports existentes.
 * Implementação modular em src/core/queue/*.
 */

export type {
  QueueItem,
  QueuePriority,
  QueueItemType,
  QueueStatus,
  QueueStats,
} from './queue/types';

export {
  enqueueEvent,
  flushQueue,
  flushQueueWithBeacon,
  sendPageViewImmediately,
  sendEventImmediately,
  setUnloadingFlag,
  startPeriodicFlush,
  stopPeriodicFlush,
  setupUnloadFlush,
  getQueueLength,
  getQueueStats,
  rehydrate,
  _testClearQueue,
  _testSetQueue,
  _testSetMaxQueueItems,
} from './queue/queueOrchestrator';
